<template>
    <div class="Summary">
        <div class="row">
            <div class="col col-md-4">
                <h4>Family Info</h4>
                <p><span class="bold">Name: </span><span>{{ FamilyRecordData.Family.Name }}</span></p>
                <p><span class="bold">Address: </span><span>{{ FamilyRecordData.Family.PhysicalAddress.AddressSingleLine }}</span> <GoogleMapsLink v-bind:address="FamilyRecordData.Family.PhysicalAddress" /></p>
                <p><span class="bold">Territory/Region: </span><span>{{ FamilyRecordData.Family.SubProgramTerritoryName }}</span></p>
                <!--<p><span class="bold">Status: </span><span>{{ FamilyRecordData.Family.Status }}</span></p>-->
                <p><span class="bold">Beds: </span><span>{{ FamilyRecordData.Family.AvailableBedsString }}</span></p>
                <p><span class="bold">Preferred Language: </span><span>{{ FamilyRecordData.Family.PreferredLanguage }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Resource Parents</h4>
                <div v-for="parentMem in FamilyRecordData.Family.Parents" style="margin-bottom:10px;">
                    <div v-if="parentMem.EndDate == null">
                        <p class="p-no-bottom-margin bold">{{parentMem.Parent.Person.FullName}}</p>
                        <p v-if="parentMem.Parent.Person.Email" class="p-no-bottom-margin">Email: <a :href="'mailto:' + parentMem.Parent.Person.Email">{{parentMem.Parent.Person.Email}}</a></p>
                        <div v-for="phoneNumber in parentMem.Parent.Person.PhoneNumbers">
                            <p class="p-no-bottom-margin">{{ phoneNumber.PhoneNumber.PhoneType }}: {{ phoneNumber.PhoneNumber.FormattedPhoneNumber }} <span v-if="phoneNumber.PhoneNumber.Description">({{ phoneNumber.PhoneNumber.Description }})</span></p>
                        </div>
                        <PersonEditor :edit-mode="true"
                                      :DOBRequired="true"
                                      :global-update="true"
                                      :existing-person="parentMem.Parent.Person" 
                                      :inline="false"/>
                    </div>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>ASW</h4>
                <div v-if="CurrentASW != null">
                    <p><span class="bold">Name: </span><span>{{ CurrentASW.Employee.Person.FullName }}</span></p>
                </div>
                <div v-else>
                    <p><span class="bold">None Assigned </span><span></span></p>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>Program Enrollment</h4>
                <p><span class="bold">Regional Program: </span><span>{{ FamilyRecordData.FamilyProgramMembership.SubProgramName }}</span></p>
                <p><span class="bold">Start Date: </span><span>{{ formatDate(FamilyRecordData.FamilyProgramMembership.StartDate, 'MM/DD/YY') }}</span></p>
                <p><span class="bold">Approval Date: </span><span>{{ formatDate(FamilyRecordData.Family.ApprovalDate, 'MM/DD/YY', 'N/A') }}</span></p>
            </div>
            
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    
    export default {
        props: [
            'FamilyRecordData'
        ],
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },

        },
        components: {
            GoogleMapsLink
        },
        mounted() {

        },
        computed: {
            CurrentResourceFamily: function () {
                let initList = this.ChildRecordData.ResourceFamilies.filter(fam => fam.EndDate == null);
                if (initList.length == 1) {
                    return initList[0];
                } else {
                    return null;
                }
            },
            CurrentASW: function () {
                let initList = this.FamilyRecordData.ASWs.filter(mem => mem.EndDate == null);
                if (initList.length == 1) {
                    return initList[0];
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>
    
</style>